module.exports = __webpack_public_path__ + "assets/france.ff3837b1e2e7fb5724961d613a16e6f7.svg?";